import utils from "../common/util";

const cmpDataContainer = {
    component: null,

    init: function (element)
    {
        utils.log('cmpDataContainer initiated : #' + element.id, 'info');
        const _ = utils.setEnvironment(this);
    },

    /**
     * Set variables that could change with each game play. Called often throughout a game
     */
    collectVariables: function ()
    {
        const _ = this;

        return {
            'currentPlayer': _.dataContainer.getAttribute('data-current-player'),
            'currentPlayerId': _.dataContainer.getAttribute('data-current-player-id'),
            'opponentPlayer': _.dataContainer.getAttribute('data-opponent-player'),
            'opponentPlayerId': _.dataContainer.getAttribute('data-opponent-player-id'),
            'genderTarget': _.dataContainer.getAttribute('data-gender-target'),
            'playScore': _.dataContainer.getAttribute('data-play-score'),
            'gameId': _.dataContainer.getAttribute('data-game-id'),
            'gameLevelId': _.dataContainer.getAttribute('data-game-level-id'),
            'playId': _.dataContainer.getAttribute('data-play-id'),
        }
    },

    /**
     * Set an individual variable for the data container object
     * @param key
     * @param value
     */
    setVariable(key, value)
    {
        return {
            key: value
        }
    },

    setData(data)
    {
        const _ = this;

        Object.keys(data).forEach(attribute =>
        {
            _.dataContainer.setAttribute(attribute, data[attribute]);
        });

    }
}

export default cmpDataContainer;
